import { AxiosError } from 'axios';

import { UserInfo } from '@/slw/shared/types/auth.type';
import { UploadedFile } from '@/slw/shared/types/file.type';
import { uploadFiles } from '@/slw/shared/api/api.service';

import { ProfileInfo, UpdatePassword, PhoneValidationResult } from './profile.type';

export const getProfile = async () => {
  return await apiClient().get<UserInfo>('/ecom-users/profile');
};

export const updateProfile = async (profile: ProfileInfo) => {
  return await apiClient().post('/ecom-users/update-profile', profile, {
    errorHandling: 'throwOnly',
  });
};

export const updatePassword = async (payload: UpdatePassword) => {
  return await apiClient().post('/ecom-users/update-password', payload);
};

export const uploadAvatar = async (file: File) => {
  try {
    const res = await uploadFiles({
      files: [file],
      applicationCode: 'ecom',
      moduleCode: 'avatar',
      functionCode: 'avatar',
    });

    return res;
  } catch (error) {

    if (error instanceof AxiosError) {
      return { 
        success: false, 
        data: null, 
        message: error.response?.data?.message || 'Upload failed' 
      };
    }

    return { 
      success: false, 
      data: null, 
      message: (error as Error).message || 'Upload error' 
    };
  }
};

export const validatePhone = async (phoneNumber: string, regionCode: string) => {
  try {
    const res = await apiClient().post<PhoneValidationResult>('/phone-validation/validate', {
      phoneNumber,
      regionCode,
    }, {
      errorHandling: 'throwOnly',
    });

    return res;
  } catch (error) {

    if (error instanceof AxiosError) {
      return { 
        success: false, 
        data: null, 
        message: error.response?.data?.message || 'Validation failed' 
      };
    }

    return { 
      success: false, 
      data: null, 
      message: (error as Error).message || 'Validation error' 
    };
  }
};
